import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from '../../shared/components/table/table.component';
import { TableColumn } from '../../core/models/column.model';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { forkJoin } from 'rxjs';
import { UpdateRecordService } from '../../core/services/update-record.service';
import { ShiftClosureService } from '../../core/services/shift-closure.service';
import { UpdateRecord } from '../../core/models/update-record.model';
import { ConfirmPopupComponent } from '../../shared/components/confirm-popup/confirm-popup.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { ModalComponent } from '../modal/modal.component';
import { Constants } from '../../shared/utils/constants';
import { ReactiveFormsModule } from '@angular/forms';
import { Alert } from '../../core/models/alert.model';

@Component({
  selector: 'app-shift-report-preview',
  standalone: true,
  imports: [
    CommonModule,
    TableComponent,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    RouterModule,
    MatDialogModule,
    MatSnackBarModule,
    ConfirmPopupComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './shift-report-preview.component.html',
  styleUrls: ['./shift-report-preview.component.scss'],
})
export class ShiftReportPreviewComponent implements OnInit {
  @Input() shiftClosureId!: number;

  origin: string | null = null;
  recordToClone: any | null = null;
  showConfirmPopup = false;
  showClonePopup = false;
  alerts: Alert[] = [];

  flattenedData: { [key: string]: any[] } = {
    [Constants.NOVEDADES]: [],
    [Constants.AVISO_AVERIAS]: [],
    [Constants.OT_EJECUTADAS]: [],
    [Constants.FUERA_SERVICIO]: [],
    [Constants.SEGURIDAD]: [],
    [Constants.PERSONAL]: [],
  };

  shiftUpdates: any[] = [];
  shiftUpdatesByArea: any[] = [];

  seguridadColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosure', isCheckbox: true },
    { header: 'Hora', field: 'hora' },
    { header: 'Tipo', field: 'tipo_novedad' },
    { header: 'Contenido', field: 'novedad' },
  ];

  personalColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosure', isCheckbox: true },
    { header: 'Hora', field: 'hora' },
    { header: 'Contenido', field: 'novedad' },
  ];

  generalTableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosure', isCheckbox: true },
    { header: 'Área', field: 'updateArea' },
  //  { header: 'Responsable', field: 'responsable' },
    { header: 'Hora', field: 'hora' },
    { header: 'Novedad', field: 'novedad' },
  ];

  reportedBreakdownNoticeTableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosure', isCheckbox: true },
    { header: 'Área', field: 'updateArea' },
  //  { header: 'Responsable', field: 'responsable' },
    { header: 'Hora', field: 'hora' },
    { header: 'Prioridad', field: 'prioridad' },
    { header: '¿Qué está mal?', field: 'que_esta_mal' },
    { header: '¿Qué tiene de malo?', field: 'que_tiene_de_malo' },
    { header: 'Debería', field: 'deberia' },
  ];

  workOrderTableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosure', isCheckbox: true },
    { header: 'Área', field: 'updateArea' },
  //  { header: 'Responsable', field: 'responsable' },
    { header: 'N° Orden de Trabajo', field: 'n_orden' },
    { header: 'Fecha', field: 'fecha', isDate: true },
    { header: 'Hora Inicio', field: 'hora_inicio' },
    { header: 'Hora Término', field: 'hora_termino' },
    { header: 'Hora Permiso Otorgado', field: 'hora_permiso' },
    { header: 'En Ejecución', field: 'en_ejecucion' },
    { header: 'Comentarios', field: 'comentarios' },
  ];

  outOfServiceTableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosure', isCheckbox: true },
    { header: 'Área', field: 'updateArea' },
  //  { header: 'Responsable', field: 'responsable' },
    { header: 'Hora', field: 'hora' },
    { header: 'Novedad', field: 'ingrese_novedad' },
  ];

  shiftUpdatesTableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosure', isCheckbox: true },
    { header: 'Hora', field: 'hora' },
  //  { header: 'Responsable', field: 'responsable' },
    { header: 'Tipo', field: 'tipo_novedad' },
    { header: 'Novedad', field: 'detalleNovedad' },
    { header: 'Fecha', field: 'fecha', isDate: true },
  ];

  constructor(
    private updateRecordService: UpdateRecordService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private shiftClosureService: ShiftClosureService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.loadDataByType(Constants.NOVEDADES);
    this.loadDataByType(Constants.AVISO_AVERIAS);
    this.loadDataByType(Constants.OT_EJECUTADAS);
    this.loadDataByType(Constants.FUERA_SERVICIO);
    this.loadDataByType(Constants.SEGURIDAD);
    this.loadDataByType(Constants.PERSONAL);
  }

  loadDataByType(type: string): void {
    const areas: string[] = [
      Constants.GENERAL,
      Constants.CLORURO_FERRICO,
      Constants.SALMUERA_I,
      Constants.SALMUERA_II,
      Constants.COMPRESION,
      Constants.ELECTROLIZADORES,
      Constants.SUBESTACION,
      Constants.MOVIMIENTO_PRODUCTO,
      Constants.DCS,
    ];
    const isClosed = false;
    const isMarkedForClosure = true;
    const isMarkedForPreClosure = false;

    this.updateRecordService
      .getUpdateRecordsByTypeAndAreas(
        type,
        areas,
        isClosed,
        isMarkedForClosure,
        isMarkedForPreClosure,
      )
      .subscribe({
        next: (updates: UpdateRecord[]) => {
          const flattened = this.flattenData(updates);
          this.flattenedData[type] = flattened.length ? flattened : [];
        },
        error: error => {
          if (error.status === 404) {
            this.flattenedData[type] = [];
          } else {
            console.error(`Error al cargar datos para tipo ${type}:`, error);
            this.flattenedData[type] = [];
          }
        },
      });
  }

  // Determina la marca de cierre a mostrar según el área del registro
  private getRoleSpecificClosureMark(update: UpdateRecord): boolean {
    const u: any = update as any;
    const areaCode = update.updateArea?.code?.toLowerCase?.() ?? '';
    if (areaCode === 'dcs') {
      return (u.isMarkedForClosureDCS ?? u.isMarkedForClosureDcs ?? update.isMarkedForClosure) as boolean;
    }
    if (areaCode === 'cloruro_ferrico' || areaCode === 'ferrico') {
      return (u.isMarkedForClosureFerrico ?? update.isMarkedForClosure) as boolean;
    }
    return update.isMarkedForClosure;
  }

  flattenData(updates: UpdateRecord[]): any[] {
    return updates.flatMap(update => {
      const elements = update.updateElements;
      const getElementValue = (label: string): string =>
        elements.find(el => el.label === label)?.updateValues?.[0]?.value || '';

      const hora = getElementValue('Hora');
      const novedad = getElementValue('Novedad');
      const tipoNovedad = getElementValue('Tipo de Novedad');
      const prioridad = getElementValue('Prioridad');
      const queEstaMal = getElementValue('¿Qué está mal?');
      const queTieneDeMalo = getElementValue('¿Qué tiene de malo?');
      const deberia = getElementValue('Debería');
      const nOrden = getElementValue('N° Orden de Trabajo');
      const horaInicio = getElementValue('Hora Inicio');
      const horaTermino = getElementValue('Hora Término');
      const horaPermiso = getElementValue('Hora Permiso Otorgado');
      const enEjecucion = getElementValue('En Ejecución');
      const comentarios = getElementValue('Comentarios');
      const horaFueraServicio = getElementValue('Hora Fuera de Servicio');
      const ingreseNovedad = getElementValue('Ingrese Novedad');

      const detalleNovedad = elements
        .filter(el => el.label !== 'Hora' && el.label !== 'Tipo de Novedad')
        .map(el => {
          const values = el.updateValues?.map(val => `${el.label}: ${val.value}`).join(', ') || '';
          return values || `${el.label}: N/A`;
        })
        .filter(txt => txt.trim() !== '')
        .join(', ');

      return {
        id: update.id,
        hora: hora ? hora : horaInicio,
        hora_inicio: horaInicio,
        hora_termino: horaTermino,
        hora_permiso: horaPermiso,
        hora_fuera_servicio: horaFueraServicio,
        ingrese_novedad: ingreseNovedad,
        en_ejecucion: enEjecucion === "true" ? "Si" : "No",
        n_orden: nOrden,
        prioridad,
        que_esta_mal: queEstaMal,
        que_tiene_de_malo: queTieneDeMalo,
        deberia,
        responsable:
          elements.find(el => el.element?.id === 2 || el.element?.id === 5)?.updateValues?.[0]
            ?.createdUser?.username || '',
        tipo_novedad: tipoNovedad ? tipoNovedad : update.updateType?.name,
        tipo: update.updateType?.name,
        area: update.updateArea?.name,
        updateArea: update.updateArea?.name,
        novedad: novedad,
        detalleNovedad,
        comentarios,
        fecha:
          elements.find(el => el.element?.id === 2 || el.element?.id === 5)?.updateValues?.[0]
            ?.createdUtc || '',
        updateElements: elements,
        updateType: update.updateType,
        isMarkedForClosure: this.getRoleSpecificClosureMark(update),
        isMarkedForPreClosure: update.isMarkedForPreClosure,
        isCloned: update.isCloned,
      };
    });
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  viewUpdateRecord(visation: any): void {
    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        record: visation,
        readOnly: true,
      },
      width: '600px',
    });
    dialogRef.afterClosed().subscribe(() => {});
  }

  onCheckboxChangeForClosure(isMarked: boolean, updateRecordId: number): void {
    this.updateRecordService.updateMarkForClosure(updateRecordId, isMarked).subscribe({
      next: () => {
        console.log('Estado actualizado correctamente.');
      },
      error: error => {
        console.error('Error al actualizar el estado:', error);
      },
    });
  }

  openCloneConfirmation(visation: any): void {
    this.recordToClone = visation;
    this.showClonePopup = true;
  }

  closeClonePopup(): void {
    this.showClonePopup = false;
    this.recordToClone = null;
  }

  confirmClone(): void {
    if (!this.recordToClone) {
      console.error('No hay registro para clonar.');
      return;
    }
    this.updateRecordService.cloneUpdateRecord(this.recordToClone.id).subscribe({
      next: clonedRecord => {
        console.log('Registro clonado exitosamente:', clonedRecord);
        // Actualizamos
        forkJoin({
          originalUpdate: this.updateRecordService.updateMarkForClosure(
            this.recordToClone.id,
            false,
          ),
          clonedUpdate: this.updateRecordService.updateMarkForClosure(clonedRecord.id, true),
        }).subscribe({
          next: () => {
            console.log('Estados (original y clon) actualizados.');
            this.ngOnInit();
            this.closeClonePopup();
          },
          error: err => {
            console.error('Error al actualizar los estados:', err);
            this.snackBar.open('Error al actualizar los estados.', 'Cerrar', { duration: 3000 });
          },
        });
      },
      error: err => {
        this.snackBar.open(err?.error || 'Ocurrió un error al clonar turno.', 'Cerrar', {
          duration: 3000,
        });
        console.error('Error al clonar el registro:', err);
      },
    });
  }

  editUpdateRecord(visation: any): void {
    if (!visation.updateElements) {
      console.error('El objeto no tiene updateElements:', visation);
      return;
    }
    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        record: visation,
        readOnly: false,
      },
      width: '600px',
    });
    dialogRef.afterClosed().subscribe((result: { success: boolean }) => {
      if (result?.success) {
        console.log('Edición exitosa. Refrescando...');
        this.ngOnInit();
      }
    });
  }

  deleteUpdateRecord(id: number): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: '¿Estás seguro de que deseas eliminar este registro?' },
    });
    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.updateRecordService.deleteUpdateRecord(id).subscribe({
          next: () => {
            console.log(`Registro con ID ${id} eliminado correctamente.`);
            this.ngOnInit();
          },
          error: error => {
            console.error(`Error al eliminar el registro con ID ${id}:`, error);
          },
        });
      }
    });
  }

  openConfirmPopup(): void {
    this.showConfirmPopup = true;
  }

  closeConfirmPopup(): void {
    this.showConfirmPopup = false;
  }

  goToPreviousShift(): void {
    this.shiftClosureService.getPreviousShiftIdByType(Constants.INFORME_TURNO).subscribe({
      next: (prevId: number) => {
        this.router.navigate(['/shift-report', prevId]);
      },
      error: err => {
        console.error('Error al obtener el turno anterior:', err);
      },
    });
  }

  goToMyNews(): void {
    this.router.navigate(['/shift-report']);
  }
}
